import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import './deeplink-button.styl'

import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import deeplinkHelper from 'client/shared/helpers/deeplink-helper'
import deviceHelper from 'shared/tools/device-helper'
import { ResourceName } from 'client/shared/types/resource'

type Props = {
  resourceType: ResourceName | 'shelf'
  campaign: string
  uuid?: string
  stage?: string
} & DecoratorProps
class DeeplinkButton extends Component<Props> {
  static defaultProps = {
    campaign: 'install_app',
  }

  getStoreLink() {
    const {
      auth,
      resourceType,
      campaign: _campaign,
      app,
      uuid,
      stage,
      isMobileOS,
    } = this.props
    const campaign = auth ? `${_campaign}_auth` : _campaign

    switch (resourceType) {
      case 'serial':
      case 'book':
        return `${deeplinkHelper.getBookStoreLink({
          uuid: uuid as string,
          campaign,
          channel: deviceHelper.getOsName(app),
          isDesktop: !isMobileOS(),
          stage: stage as string,
        })}`
      case 'comicbook':
        return `${deeplinkHelper.getComicbookStoreLink({
          uuid: uuid as string,
          campaign,
          channel: deviceHelper.getOsName(app),
          isDesktop: !isMobileOS(),
          stage: stage as string,
        })}`
      case 'audiobook':
        return `${deeplinkHelper.getAudioBookStoreLink({
          uuid: uuid as string,
          campaign,
          channel: deviceHelper.getOsName(app),
          isDesktop: !isMobileOS(),
          stage: stage as string,
        })}`
      case 'shelf':
        return `${deeplinkHelper.getShelfStoreLink({
          uuid: uuid as string,
          campaign,
          channel: deviceHelper.getOsName(app),
          isDesktop: !isMobileOS(),
          stage: stage as string,
        })}`
    }
  }

  getButtonText() {
    const { resourceType } = this.props

    switch (resourceType) {
      case 'serial':
      case 'book':
      case 'comicbook':
        return 'buttons.read_in_app'
      case 'audiobook':
        return 'buttons.listen_in_app'
      case 'shelf':
      default:
        return 'buttons.open_in_app'
    }
  }

  render() {
    return (
      <a href={this.getStoreLink()} className="deeplink-button">
        <Trans id={this.getButtonText()} />
      </a>
    )
  }
}

export default uiBox(DeeplinkButton)
